<section class="card bg-base-100 border border-base-300 shadow h-full">
  <div class="card-body">
    <div class="flex w-full flex-wrap justify-between items-center gap-4">
      <h3 class="card-title text-base">
        <span class="icon-[mdi--devices] text-xl text-success"></span>
        디바이스 유형
      </h3>
      <div class="flex flex-wrap gap-2 items-center">
        <div class="flex items-center gap-1.5">
          <lepi-date-range
            [(startAt)]="startAt"
            [(endAt)]="endAt"
            (startAtChange)="handleDateChange()"
            (endAtChange)="handleDateChange()" />
          @if (startAt() || endAt()) {
            <button (click)="handleReset()" class="btn btn-ghost btn-sm btn-square tooltip" data-tip="기간 초기화">
              <span class="icon-[mdi--refresh] text-lg text-base-content/60"></span>
            </button>
          }
        </div>
      </div>
    </div>
    @if (data()) {
      <div class="flex flex-col xl:flex-row w-full gap-8 justify-center items-center">
        <lepi-chart [options]="options()" />
        <div class="flex flex-col gap-3 p-5 bg-base-200/50 rounded-xl">
          <div class="flex gap-3 items-center">
            <div class="bg-[#2b7fff] size-3.5 rounded-full"></div>
            <p class="text-base-content text-sm">데스크탑 ({{ getPercent((oses()?.counts)![0], oses()!.counts) }})</p>
          </div>
          <div class="flex gap-3 items-center">
            <div class="bg-[#FF9800] size-3.5 rounded-full"></div>
            <p class="text-base-content text-sm">IOS ({{ getPercent((oses()?.counts)![1], oses()!.counts) }})</p>
          </div>
          <div class="flex gap-3 items-center">
            <div class="bg-[#34C759] size-3.5 rounded-full"></div>
            <p class="text-base-content text-sm">안드로이드 ({{ getPercent((oses()?.counts)![2], oses()!.counts) }})</p>
          </div>
        </div>
      </div>
    }
  </div>
</section>
